import React,{ useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Combobox, Transition } from "@headlessui/react";


import { debounce } from "lodash";
import LogicContext from "../../Context/LogicContext";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import { rewardService } from "../../services/Reward.service";



function RewardRedeemSearch(props: any) {

  
  const [textInput, setTextInput] = useState("");
  const navigate = useNavigate();
  const isMounted = useRef(false);
    const logicContext = useContext(LogicContext);

  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  useEffect(()=> {
    isMounted.current = true;

    return ()=> {
      isMounted.current = false;
    }
  })



    const debouncedSearch = React.useRef(
      debounce((search: string) => {
        let isMounted = true;
        if (search.length > 2) {
          rewardService.rewardRedeemSearch(search).then((res) => {
            if (isMounted && res?.data?.length) {
              props.searchList([res.data]);
            
            } else if (isMounted) {
              logicContext.showToast(
                "No available record for your search query!",
                ""
              );
            
              props.searchList([]);
            }
          });
        }
        return () => {
          isMounted = false;
        };
      }, 500)
    ).current;

  function selectedOption(selection: any) {
    const { Subscription_Ref_No } = selection;
    setTextInput("");
    navigate(
      `/${currModuleId}/${currModuleName}/${currUserMenu}/details/${Subscription_Ref_No}`
    );
  }

  return (
    <>
      <Combobox>
        <div className="relative max-w-sm w-full">
          <div className="relative">
            <Combobox.Input
              className=" w-full rounded-full border font-medium border-gray-300 bg-white py-1.5 pl-10 pr-4 text-sm text-gray-800 placeholder-gray-400 focus:border-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-600"
              // displayValue={(person) => person.name}
              placeholder="Search in Reward redeem"
              onChange={(e) => {
                const val = e.target.value;
                setTextInput(val);
                debouncedSearch(val);
              }}
            />
            <Combobox.Button className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-5 text-gray-500"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                />
              </svg>
            </Combobox.Button>
          </div>
          <Transition
         
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => 
              setTextInput("")
            }
          >

          </Transition>
        </div>
      </Combobox>
    </>
  );
}

export default RewardRedeemSearch;
